export default "__VITE_ASSET__D8t1OzpL__"